import { BaseView } from 'Common/BaseView';

export class ErrorBaseView extends BaseView {

    constructor() {
        super();
    }
    
    public GoBack() {
        window.history.back();
    }
}